export default __webpack_public_path__ + "static/media/privacy-policy-en-2.185b3b3e.jpg";